<template>
    <!-- 有个体 -->
    <div class="item_list">
      <div class="item_list_inner" v-if="$store.state.item.length">
        <!-- <p class="individual" @click="searchIndividual()" v-if="!$store.state.isInvididual">查个体</p>
        <p class="individual" @click="searchCompany()" v-else>查企业</p> -->
        <ul class="list">
          <li v-for="(item,index) in $store.state.item" @click="item_input(index)" >
            {{item.entName}}
            <span class="statusCode" v-if="item.entStatusCode==1">{{item.entStatus}}</span>
            <span class="statusCode green" v-else-if="item.entStatusCode==4||item.entStatusCode==6||item.entStatusCode==9">{{item.entStatus}}</span>
            <span v-else><span class="statusCode red" v-if="item.entStatus">{{item.entStatus}}</span></span>
          </li>
        </ul>
      </div>
      <!-- <div class="item_list_inner" v-else>
        <ul class="list">
          <li v-for="(item,index) in $store.state.item" @click="item_input(index)" >{{item}}</li>
        </ul>
      </div> -->
    </div>
</template>

<script >
   export default {
   		data:function(){
   			return {
   			}
   		},
   		mounted(){
            $("ul.list li").each(function(){
                $(this).removeClass("cur")
            })
   		},
   		methods : {
   			item_input : function(index){
          this.$emit('itemZhi',this.$store.state.item[index])
          if(this.$store.state.item[index].entType ===2 ){
              this.$store.state.isInvididual = true
          }else{
               this.$store.state.isInvididual = false
          }
   				// 开锁
          this.$store.state.multicheck_isclick = false
        },
        searchIndividual(){

          this.$store.state.isInvididual = !this.$store.state.isInvididual
          this.$emit('individual')
          console.log(this.$store.state.isInvididual)
        },
        searchCompany(){

          this.$store.state.isInvididual = !this.$store.state.isInvididual
          this.$emit('companySearch')
        }
   		}
   }
</script>

<style type="text/css">
.statusCode{
  
  color :#1890ff;
  background :rgba(255, 255, 255, 0.1);
      font-size: 12px;
    height: 20px;
    line-height: 20px;
    padding: 0 6px;
    border-radius: 3px;
    display: inline-block;
}
.green{
  color:#03A871;
  /* background:#E5F6F0; */
}
.red{
  color:#FE3D3D;
  /* background:#FEEBEB; */
}
    .w_b{
        position: relative;
        width: 100%;
    }
	.w_b .item_list{
		color:#d3d3dd;
    width: 620px;
    height: 350px;
    background-color: #232458;
		position: absolute;
		z-index: 23;
		top:85px;
    left: 0;
	}
  .w_b .item_list .individual{
    position: absolute;
    bottom:0px;
    right:10px;
    width: 60px;
    text-decoration: underline;
    cursor: pointer;
    z-index: 6666;
  }
	.item_list ul.list li{
		padding-left: 20px;
    font-size: 14px;
    font-family: "SimSun";
    line-height: 46px;
    color:#a7a7a7;
    text-overflow:ellipsis;
    white-space:nowrap;
    overflow:hidden;
    text-align:left;
    position: relative;
	}
  .item_list ul.list li p.legelName{
    position: absolute;
    top:16px;
    left:19px;
    font-size: 12px;
  }
  /*.item_list ul.list li p.active{
    line-height: 46px;
  }
  .item_list ul.list li p.legelName{
    font-size: 12px;
  }*/
    .item_list ul.list li.cur{
        background-color: #373a8b;
        cursor: pointer;
        color:#fff;
    }
	.item_list ul.list li:hover{
		background-color: #373a8b;
		cursor: pointer;
        color:#fff;
	}
  @media screen and (max-width: 1440px){
    .w_b .item_list{
    color:#d3d3dd;
        width: 620px;
        height: 280px;
        background-color: #232458;
    position: absolute;
    z-index: 23;
    top:73px;
        left: 0;
  }
  .item_list ul.list li{
    padding-left: 20px;
        font-size: 14px;
        font-family: "SimSun";
        line-height: 46px;
        color:#a7a7a7;
        text-overflow:ellipsis;
        white-space:nowrap;
        overflow:hidden;
        text-align:left;
  }
  .item_list ul.list li p.legelName{
    position: absolute;
    top:16px;
    left:19px;
    font-size: 12px;
  }
  }
</style>



// WEBPACK FOOTER //
// ItemList.vue?60824058